module.exports = __webpack_public_path__ + "img/66000.9ebd8a7e.jpg";